import { createSlice } from '@reduxjs/toolkit';
import { convertArrayToObject } from "../../helpers/common-helper";

export interface TablesState {
  tablesList: any[];
  allTableData: Record<string, any>;
  allTableDataWithName: Record<string, Record<any,any>>;
}

const initialState: TablesState = {
  tablesList: [],
  allTableData: {},
  allTableDataWithName: {}
};

export const tablesSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    saveTablesData: (state, actions) => {
      state.tablesList = actions.payload;
    },
    saveAllTablesData: (state, actions) => {
      state.allTableData = convertArrayToObject(actions.payload, 'mid');
      state.allTableDataWithName = convertArrayToObject(actions.payload, 'name');
    }
  },
});

export const { saveTablesData, saveAllTablesData } = tablesSlice.actions;
export default tablesSlice.reducer;
